// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__L-Qs_","rootSmall":"AddTileButton_rootSmall__3MiHZ"};